module.exports = __webpack_public_path__ + "static/og-f0dfeb3ce6d0306e9b91ab21f6c12ae3.png";